import fetchData from '@/lib/fetchData';

import { GET_ACT_LPO } from '@/lib/rootApi';

import lease from './lease';
import geometry from './geometry';
import uploads from './uploads';

export default {
	namespaced: true,

	modules: {
		lease,
		geometry,
		uploads
	},

	state: {
		actLpo: null,
		actLpoLoading: false,
	},
	mutations: {
		setActLpo(state, actLpo) { state.actLpo = actLpo; },
		setActLpoLoading(state, loading) { state.actLpoLoading = loading; }
	},
	actions: {
		getActLpo(state, act_id) {
			
			const form = new FormData();
			form.append('act_id', act_id);

			commit('setActLpoLoading', true);

			return fetchData(GET_ACT_LPO, form).then(act => {
				commit('setActLpo', act);
			}).finally(() => {
				commit('setActLpoLoading', false);
			});
		}
	}
};